import React, { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import 'datatables.net-buttons/js/dataTables.buttons.min.js';
import 'datatables.net-buttons/js/buttons.html5.min.js';
import 'datatables.net-buttons/js/buttons.print.min.js';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import jszip from 'jszip';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { API_URL } from '..';

window.JSZip = jszip;
pdfMake.vfs = pdfFonts.pdfMake?.vfs;
const DriverTable = ({jobsData}) => {
  const history = useNavigate();
  const [currentUser, setCurrentUser]= useState({})
  console.log(jobsData)
      const handleDelete = async(id)=>{
        
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         let response = await fetch(`${API_URL}/api/jobs/${id}`, { 
           method: "DELETE",
           headers: headersList
         });
         let data = await response.json();
         if(data.message=="Job status delete successfully"){
            window.location.reload();
         }
      
       
      }
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'))
      setCurrentUser(user)
        const table = $('#dataTable').DataTable({
        data: jobsData,
        responsive:true,
        pageLength: 10,
        dom: 'Bfrtip',
        buttons: ['copy', 'csv', 'excel', 'pdf', 'print'],
         columns: [
            { data: 'id' },
            { data: 'first_name',render:(data,type,row)=>( data ?? (`${data} ${row.last_name}`) ) },
            { data: 'phone_number' },
            { data: 'truck.name' },
            { data: 'status' },
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
                <div class="dropdown">
                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ph ph-list"></i>
                </button>
                <ul class="dropdown-menu">
                  
                  <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Driver</a></li>
                  <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Driver</a></li>
                </ul>
              </div>
            
               
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
            
        });
        $('#dataTable tbody').on('click', '.view-btn', function () {
          const id = $(this).data('id');
          history(`/drivers-view/${id}`); // Navigate to the edit page
        });
    
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);

    return (
        <div className="card basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0">Drivers</h5>
            <div class="col-md-6 text-end">
            <Link className="btn btn-info" to={'/add-driver'}>
              Add New
            </Link>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className="table bordered-table mb-0" id="dataTable">
            <thead>
              <tr>
                <th scope="col">
                  <div className="form-check style-check d-flex align-items-center">
                    
                    <label className="form-check-label">ID</label>
                  </div>
                </th>
                <th scope="col">Driver Name</th>
                <th scope="col">Phone</th>
                <th scope="col">Vehicle Info</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {/* DataTables will populate this tbody */}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default DriverTable